module.exports = __webpack_public_path__ + "assets/ozon.4b9e6da0.svg";